/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Move_DownInputs */

const en_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move down`)
};

const fr_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descendre`)
};

const de_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach unten schieben`)
};

const it_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scendendo`)
};

const ru_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спуститесь вниз`)
};

const es_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baja`)
};

const zh_cn2_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向下`)
};

const ja_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下へ移動`)
};

const hi_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नीचे की ओर`)
};

const pt_pt2_media_tab_move_down = /** @type {(inputs: Media_Tab_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desça`)
};

/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Media_Tab_Move_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_move_down = /** @type {((inputs?: Media_Tab_Move_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Move_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_move_down(inputs)
	if (locale === "de") return de_media_tab_move_down(inputs)
	if (locale === "it") return it_media_tab_move_down(inputs)
	if (locale === "ru") return ru_media_tab_move_down(inputs)
	if (locale === "es") return es_media_tab_move_down(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_move_down(inputs)
	if (locale === "ja") return ja_media_tab_move_down(inputs)
	if (locale === "hi") return hi_media_tab_move_down(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_move_down(inputs)
	return en_media_tab_move_down(inputs)
});